import themeVariables from "@/config/theme/themeVariable";
import { Modal, Button } from "@mantine/core";
import { useDisclosure } from "@mantine/hooks";
import { useSearchParams, useRouter } from "next/navigation";
import { useEffect } from "react";

interface AnesthesiaModalProps {
  forceOpened?: boolean;
  onClose?: () => void;
}

// 마취 관련 메뉴 아이템들을 key-value로 관리
const anesthesiaMenuItems = {
  types: {
    label: "마취의 종류",
    path: "/anesthesia?from_modal=anesthesia"
  },
  cautions: {
    label: "주의사항", 
    path: "/anesthesia-cautions"
  }
} as const;

export const AnesthesiaModal = ({ forceOpened = false, onClose }: AnesthesiaModalProps) => {
  const [opened, { open, close }] = useDisclosure(forceOpened);
  const searchParams = useSearchParams();
  const router = useRouter();
  
  useEffect(() => {
    if (searchParams?.get('modal') === 'anesthesia' || forceOpened) {
      open();
    }
  }, [searchParams, open, forceOpened]);

  const handleClose = () => {
    close();
    if (onClose) onClose();
  };

  const handleMenuItemClick = (path: string) => {
    router.push(path);
    handleClose();
  };

  return (
    <Modal
      opened={opened}
      onClose={handleClose}
      withCloseButton={false}
      centered
      radius={'lg'}
      padding={24}
      size="lg"
      closeOnClickOutside={true}
      classNames={{ 
        content: 'scrollbar-hide max-w-full md:max-w-[700px]', 
        overlay: 'cursor-pointer' 
      }}
    >
      <div className="flex flex-col gap-3 mb-5">
        <div className="text-lg text-gray-700 dark:text-gray-100 font-semibold" data-autofocus>
          마취 종류
        </div>
      </div>
      
      <div className="mt-6 grid grid-cols-2 md:grid-cols-4 gap-3 mb-4 max-w-[560px] mx-auto">
        {Object.entries(anesthesiaMenuItems).map(([key, item]) => (
          <div
            key={key}
            className={`flex flex-col items-center justify-center gap-3 border border-gray-200 dark:border-gray-700 p-4 text-center h-[76px] text-gray-700 text-[15px] font-normal hover:border-blue-700 hover:text-blue-700 dark:hover:text-blue-400 transition-colors cursor-pointer rounded-lg bg-white dark:bg-gray-800`}
            onClick={() => handleMenuItemClick(item.path)}
          >
            <div className="text-[15px] font-normal">
              {item.label}
            </div>
          </div>
        ))}
      </div>

      <div className="flex gap-1 justify-end mt-5">
        <Button 
          classNames={themeVariables.button.gray} 
          onClick={handleClose}
        >
          닫기
        </Button>
      </div>
    </Modal>
  );
};